const remotePrintableClinics = [218];

/**
 * Checks if a clinic is allowed for remote printing
 * @param { string } clinicId
 * @returns { boolean }
 */
export default function isRemotePrintableClinic(clinicId) {
  return remotePrintableClinics.includes(clinicId);
}
